import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Badge,
  UncontrolledTooltip,
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  Input,
  FormFeedback,
  Label,
} from "reactstrap"
import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import { withRouter, Link, useLocation } from "react-router-dom"
import { getDateString, getOrderPrefix } from "helpers/common_helper"
import { Type } from "react-bootstrap-table2-editor"
import { WindowScrollController } from "@fullcalendar/core"

const columns = () => {

  const columns = [
    {
      dataField: "Sno",
      text: "S#",
      sort: true,
      // Product Name column can't be edit anymore
      editable: false,
      formatter: (cell, row, rowIndex, formatExtraData) => {
        return rowIndex + 1
      },
    },
    {
      dataField: "orderCode",
      text: "Number",
      sort: true,
      // Product Name column can't be edit anymore
      editable: false,
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, row) => (
        <Link to="#" className="text-body fw-bold">
          {getOrderPrefix(row.requestFor) + row.orderCode}
        </Link>
      ),
    },
    // {
    //   dataField: "submitDateTime",
    //   text: "Received Date",
    //   sort: true,
    //   // Product Name column can't be edit anymore
    //   editable: false,
    //   formatter: (cellContent, row) => getDateString(row.submitDateTime),
    // },
    {
      dataField: "sentDate",
      text: "Payment Date",
      sort: true,
      // Product Name column can't be edit anymore
      editable: false,
      formatter: (cellContent, row) => getDateString(row.submitDateTime),
    },

  
  
    {
      dataField: "orderName",
      text: "Design Name",
      sort: true,
      // Product Name column can't be edit anymore
      editable: false,
      editor: {
        type: Type.TEXT,
      },
    },
    {
      dataField: "paymentStatus",
      text: "Price Status",
      sort: true,
      // Product Name column can't be edit anymore
      editable: false,
       formatter: (cellContent, row) => (
        row.paymentStatus ? <Badge color="success">Paid</Badge> : <Badge color="danger">Payble</Badge>
      ),
    },
    {
      dataField: "price",
      text: "price",
      sort: true,
      // Product Name column can't be edit anymore
      editable: false,
    },

   
   
  ]

  let filterdColumns = []

  switch (location.pathname.split("/")[2]) {
    case "todays-vectors":
    case "todays-orders":
    case "todays-quote":
      filterdColumns = columns.filter(
        r =>
          r.dataField === "Sno" ||
          r.dataField === "orderCode" ||
          r.dataField === "orderStatus" ||
          r.dataField === "assTo" ||
          r.dataField === "submitDateTime" ||
          r.dataField === "userName" ||
          r.dataField === "orderName" ||
          r.dataField === "process" ||
          r.dataField === "action"
      )
      break
    case "ready-orders":
    case "ready-vectors":
    case "ready-quotes":
      filterdColumns = columns.filter(
        r =>
          r.dataField === "Sno" ||
          r.dataField === "orderCode" ||
          r.dataField === "submitDateTime" ||
          r.dataField === "sentDate" ||
          r.dataField === "userName" ||
          r.dataField === "orderName" ||
          r.dataField === "orderStatus" ||
          r.dataField === "assTo" ||
          r.dataField === "process" ||
          r.dataField === "action"
      )
      break
    case "all-orders":
    case "all-vectors":
    case "all-quotes":
      filterdColumns = columns.filter(
        r =>
          r.dataField === "Sno" ||
          r.dataField === "oStatus" ||
          r.dataField === "orderCode" ||
          r.dataField === "submitDateTime" ||
          r.dataField === "sentDate" ||
          r.dataField === "userName" ||
          r.dataField === "orderName" ||
          r.dataField === "orderStatus" ||
          r.dataField === "assTo" ||
          r.dataField === "assToSalesMan" ||
          r.dataField === "action"
      )
      break
    case "vector-with-price-zero":
    case "orders-with-price-zero":
      filterdColumns = columns.filter(
        r =>
          r.dataField === "Sno" ||
          r.dataField === "orderCode" ||
          r.dataField === "submitDateTime" ||
          r.dataField === "sentDate" ||
          r.dataField === "userName" ||
          r.dataField === "orderName" ||
          r.dataField === "orderStatus" ||
          r.dataField === "stitches" ||
          r.dataField === "price"
      )
      break
    case "orders-with-price":
    case "vector-with-price":
      filterdColumns = columns.filter(
        r =>
          r.dataField === "Sno" ||
          r.dataField === "orderCode" ||
          r.dataField === "submitDateTime" ||
          r.dataField === "sentDate" ||
          r.dataField === "userName" ||
          r.dataField === "orderName" ||
          r.dataField === "orderStatus" ||
          r.dataField === "price" ||
          r.dataField === "process"
      )
      break

    default:
      filterdColumns = columns.filter(
        r =>
          r.dataField === "Sno" ||
          r.dataField === "orderCode" ||
          r.dataField === "oStatus" ||
          r.dataField === "assTo" ||
          r.dataField === "submitDateTime" ||
          r.dataField === "userName" ||
          r.dataField === "orderName" ||
          r.dataField === "process" ||
          r.dataField === "action"
      )
      break
  }

  return columns
}


export default columns
